import React from "react";

import './ThemeContainer.scss';

export const ThemeContainer = (props: React.PropsWithChildren<React.ReactNode>) => {
    return <div className="ThemeContainer">
        {props.children}
    </div>
}